/**
 * 文件说明:
 * ----------------------------------------
 * 创建用户: leo
 * 创建日期 2019/3/4
 */
import globalConstants from 'common/constants'

export default {
    ...globalConstants,
    groupStatusMap: {
        0: '正常',
        1: '离职待继承',
        2: '离职继承中',
        3: '离职继承完成',
    },
}
